module.exports = __webpack_public_path__ + "static/media/Cursor-Right.ce735738.png";